import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';
import { ApiService } from '../../../services/api.service';
import { UiService } from '../../../services/ui.service';

@Component({
  selector: 'app-password-enter-email',
  templateUrl: './password-enter-email.component.html',
  styleUrls: ['./password-enter-email.component.scss']
})
export class PasswordEnterEmailComponent implements OnInit {

  public form: UntypedFormGroup = this.fb.group({
    email: new UntypedFormControl('', [Validators.required, CustomValidators.email()])
  });
  public errors = null;
  public busy = false;
  public messages: Array<any> = [];

  constructor(
    private fb: UntypedFormBuilder,
    private api: ApiService,
    private ui: UiService,
    private router: Router,
    public transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid) {
      this.busy = true;
      this.api.sendOnetimePassword(this.form.value.email).subscribe({
        next: (result: any) => {
          this.router.navigate(['/password/renew', this.form.value.email]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', error.message, this.transloco.translate('common.messages.error')); // @translate server
        }
      }).add(() => {
          this.busy = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.messages.error_on_form'), this.transloco.translate('common.messages.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
